//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"AnchorCenter",1,0],[0,"Method",1,0],[0,"ZoomSensitivity",1,0]],[[["view"],"Start",{},1,0],[["point1","view"],"FirstPoint",{},2,0],[["point2","view"],"SecondPoint",{},2,0],[["view"],"Finish",{},1,0],[["enable"],"Enable",{},1,0]],[]];
SPLM.Display.NonProportionalZoom = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.NonProportionalZoom";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.NonProportionalZoom.MethodType = Object.freeze({
    "Rectangle" : "Rectangle", "Dynamic" : "Dynamic"});

export default SPLM;